import { fetchWithAuth } from './auth';
import {
  ApiMemberReview,
  ApiMemberRatingSummary,
  MemberReview,
  MemberRatingSummary,
  CreateMemberReviewPayload,
  UpdateMemberReviewPayload,
} from '../types/memberReview';

const ADMIN_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

function mapReview(api: ApiMemberReview): MemberReview {
  return {
    id: api.id,
    memberId: api.member_id,
    storeId: api.store_id,
    reservationId: api.reservation_id,
    rating: api.rating,
    comment: api.comment,
    wouldWelcomeBack: api.would_welcome_back,
    visibility: api.visibility,
    isDeleted: api.is_deleted,
    history: api.history,
    createdBy: api.created_by,
    createdAt: api.created_at,
    updatedBy: api.updated_by,
    updatedAt: api.updated_at,
    storeName: api.store_name,
    memberName: api.member_name,
    reservationCheckIn: api.reservation_check_in,
    creatorName: api.creator_name,
  };
}

function mapSummary(api: ApiMemberRatingSummary): MemberRatingSummary {
  return {
    memberId: api.member_id,
    avgRating: api.avg_rating,
    reviewCount: api.review_count,
    wouldWelcomeBackCount: api.would_welcome_back_count,
    flaggedCount: api.flagged_count,
  };
}

export async function listReviewsForMember(memberId: number): Promise<MemberReview[]> {
  const data: ApiMemberReview[] = await fetchWithAuth(
    `${ADMIN_API_BASE_URL}/member-reviews/?member_id=${memberId}&limit=500`
  );
  return data.map(mapReview);
}

export async function getMemberRatingSummary(memberId: number): Promise<MemberRatingSummary> {
  const data: ApiMemberRatingSummary = await fetchWithAuth(
    `${ADMIN_API_BASE_URL}/member-reviews/member/${memberId}/summary`
  );
  return mapSummary(data);
}

export async function createReview(payload: CreateMemberReviewPayload): Promise<MemberReview> {
  const data: ApiMemberReview = await fetchWithAuth(
    `${ADMIN_API_BASE_URL}/member-reviews/`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    }
  );
  return mapReview(data);
}

export async function updateReview(id: number, payload: UpdateMemberReviewPayload): Promise<MemberReview> {
  const data: ApiMemberReview = await fetchWithAuth(
    `${ADMIN_API_BASE_URL}/member-reviews/${id}`,
    {
      method: 'PUT',
      body: JSON.stringify(payload),
    }
  );
  return mapReview(data);
}

export async function deleteReview(id: number): Promise<void> {
  await fetchWithAuth(
    `${ADMIN_API_BASE_URL}/member-reviews/${id}`,
    { method: 'DELETE' }
  );
}
